<template>
  <div class="cooperation-my-visa-change-cp-container">
    <div class="visa-text-container" @click="handDetail">
      <div class="visa-title-banner">
        <span class="left-title">{{ item.pactName }}</span>
        <span class="right-icon">
          {{ item.altertype }}
        </span>
      </div>
      <div class="visa-text-content">
        <span>变更单号：</span>
        <span>{{ item.altercode }}</span>
      </div>
      <div class="visa-text-content">
        <span>所属公司：</span>
        <span>{{ item.theirCompany }}</span>
      </div>
      <div class="visa-text-content">
        <span>申报日期：</span>
        <span>{{
          item.applydate && moment(item.applydate).format('YYYY-MM-DD')
        }}</span>
      </div>
      <div class="visa-text-content-rest">
        <div>
          <span>一单一估状态：</span>
          <span style="color:#36C490">{{ item.approvestate }}</span>
        </div>
        <div>
          <span>一单一结状态：</span>
          <span
            :style="{
              color: item.qrstatus == '已确认' ? '#36C490' : '#C18858'
            }"
            >{{ item.qrstatus }}</span
          >
        </div>
      </div>
      <div class="visa-text-money">
        <div>
          <span class="span_1">一单一估</span>
          <span>估算金额：</span>
          <span>{{ item.applyamountBz | money2 }}</span>
        </div>
        <div v-if="item.qrstatus == '已确认'">
          <span class="span_1">一单一结</span>
          <!-- <span>申报金额：</span>
					<span>{{item.budgetdocno | money }}</span> -->
          <span>确认金额：</span>
          <span>{{ item.qrapproveamountBz | money2 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { getUrlParams } from 'common/js/mUtils';

export default {
  name: 'cooperation-my-visa-change-cp',

  data() {
    return {
      testData: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      moment
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},

  components: {},

  methods: {
    handDetail() {
      let { item } = this;
      let { contractguid } = item;
      let { employeeName, mobile } = getUrlParams();

      this.$router.push({
        name: 'cooperationDetail',
        query: {
          contractguid,
          index: 2,
          employeeName: decodeURIComponent(employeeName),
          mobile
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-my-visa-change-cp-container {
  padding-bottom: 30px;
  .visa-text-container {
    padding: 20px;
    padding-left: 0px;
    padding-bottom: 0px;
    position: relative;

    .visa-title-banner {
      padding-left: 20px;
      .left-title {
        width: 83%;
        color: #000000;
        font-size: 28px;
        display: inline-block;
        line-height: 1.5;
      }
      .right-icon {
        width: 120px;
        height: 40px;
        font-size: 22px;
        color: white;
        line-height: 40px;
        text-align: center;
        background: #36c490;
        display: inline-block;
        position: absolute;
        right: 0;
      }
    }
    .visa-text-content {
      font-size: 26px;
      margin-top: 10px;
      padding-left: 20px;
      display: flex;
      span:nth-child(1) {
        color: #999;
        width: 140px;
        display: inline-block;
        line-height: 1.5;
      }
      span:nth-child(2) {
        color: #666666;
        flex: 1;
        line-height: 1.5;
        max-width: 100%;
      }
    }
    .visa-text-content-rest {
      display: flex;
      margin-top: 20px;
      justify-content: space-between;
      color: #666;
      font-size: 26px;
      padding-bottom: 40px;
      padding-left: 20px;
    }
    .visa-text-money {
      padding: 28px 0px;
      padding-bottom: 0px;
      border-top: 1px solid #efefef;
      padding-left: 20px;
      color: #666;
      div:nth-child(1) {
        margin-bottom: 40px;
      }
      div:nth-child(2) {
        span:nth-child(4) {
          margin-left: 70px;
        }
      }
      .span_1 {
        width: 120px;
        display: inline-block;
        background: #efefef;
        height: 40px;
        color: #36c490;
        line-height: 40px;
        text-align: center;
        font-size: 24px;
        margin-right: 20px;
      }
    }
  }
  .visa-info-box {
    height: 130px;
    margin-top: 20px;
    width: 90%;
    display: flex;
    margin-left: 5%;
    background: rgba(239, 239, 239, 0.38);
    flex-wrap: wrap;
    font-size: 26px;
    .visa-info-item {
      color: #666666;
      text-align: center;
      line-height: 65px;
      width: 50%;
    }
  }
  .visa-details-container {
    display: flex;
    flex-wrap: wrap;
    .visa-details-item-many {
      padding-top: 10px;
      width: 33%;
      height: 166px;
      border-bottom: 1px solid #efefef;
    }
    .visa-details-item {
      padding-top: 10px;
      width: 33%;
      height: 166px;
      border-bottom: 1px solid #efefef;
    }
    .visa-details-item:nth-last-child(1) {
      border-bottom: none;
    }
    .visa-details-item:nth-last-child(2) {
      border-bottom: none;
    }
    .visa-details-item:nth-last-child(3) {
      border-bottom: none;
    }
    .visa-details-item-many:nth-last-child(1) {
      border-bottom: none;
    }
    .visa-details-item-many:nth-last-child(2) {
      border-bottom: none;
    }
    .visa-details-item-many:nth-last-child(3) {
      border-bottom: none;
    }
    .visa-details-item-many:nth-last-child(4) {
      border-bottom: none;
    }
  }
}
</style>
<style lang="scss">
.cooperation-my-visa-change-cp-container {
}
</style>
